var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraficrule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0093 4.69052H2.5729C1.91836 4.69052 1.30927 4.46325 0.818359 4.09961V18.236C0.818359 19.2087 1.60927 19.9996 2.5729 19.9996H16.0093C16.3365 19.9996 16.5911 19.736 16.5911 19.4178V4.58143C16.4184 4.65415 16.2184 4.69052 16.0093 4.69052ZM8.70927 16.2269C6.40927 16.2269 4.52745 14.3542 4.52745 12.0451C4.52745 9.73597 6.40018 7.86325 8.70927 7.86325C11.0184 7.86325 12.8911 9.73597 12.8911 12.0451C12.8911 14.3542 11.0093 16.2269 8.70927 16.2269Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99013 12.4362L5.69922 12.1816C5.76286 13.5816 6.78104 14.7362 8.1174 14.9998V13.7089C7.56285 13.5089 7.12649 13.0271 6.99013 12.4362Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29187 12.0356C9.29187 12.0083 9.28278 11.9811 9.28278 11.9538C9.24641 11.6811 9.00096 11.4629 8.71005 11.4629C8.41914 11.4629 8.17369 11.6811 8.12823 11.9629C8.12823 11.9902 8.12823 12.0174 8.11914 12.0447V12.0538C8.11914 12.3811 8.38278 12.6356 8.70096 12.6356C9.01914 12.6356 9.29187 12.372 9.29187 12.0356C9.29187 12.0447 9.29187 12.0447 9.29187 12.0356Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71009 10.2904C9.40099 10.2904 10.001 10.6904 10.2828 11.2722L11.5374 11.0267C11.1192 9.8722 10.0101 9.04492 8.71009 9.04492C7.41009 9.04492 6.30099 9.8722 5.88281 11.0267L7.13736 11.2722C7.41918 10.6904 8.01918 10.2904 8.71009 10.2904Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29102 13.6991V14.9901C10.6274 14.7264 11.6456 13.5719 11.7092 12.1719L10.4183 12.4264C10.291 13.0264 9.85465 13.5082 9.29102 13.6991Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5729 3.51818H16.0093C16.3365 3.51818 16.5911 3.25455 16.5911 2.93636V0.581818C16.5911 0.254545 16.3274 0 16.0093 0H2.5729C1.60927 0 0.818359 0.790909 0.818359 1.75455C0.818359 2.71818 1.60927 3.51818 2.5729 3.51818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraficrule);
export default __webpack_public_path__ + "static/media/traficrule.1170d035afc403a5a847f65cca92509b.svg";
export { ForwardRef as ReactComponent };